export function isNumeric(value: string) {
  return /^-?\d+$/.test(value)
}
